import { schema } from "normalizr";

const industrySchema = new schema.Entity("industries", { idAttribute: "id" });

export default industrySchema;



// WEBPACK FOOTER //
// ./src/schemas/industry.js